const getSuffix = (property) => {
  const { isPercentage } = property || {}
  let symbol = ''
  if (isPercentage) symbol = '%'
  return symbol
}

export { getSuffix }
